import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Platform', href: '/#platform' },
    { name: 'About', href: '/about' },
    { name: 'Technology', href: '/#technology' },
    { name: 'Contact', href: '/#register' }
  ];

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-400 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/80 backdrop-blur-sm'
      }`}
      style={{ height: '80px', borderBottom: scrolled ? '1px solid #E0E0E0' : 'none' }}
    >
      <div className="h-full px-[7.6923%] flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <a href="/">
            <img
              src="https://customer-assets.emergentagent.com/job_4717bcb5-d9a7-4674-a599-40a9fbf140e2/artifacts/vs2fmn5w_logo.png"
              alt="Immersid Logo"
              className="h-10 object-contain cursor-pointer transition-all duration-400 hover:opacity-80"
            />
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-[#808080] hover:text-[#FF8000] text-lg font-normal transition-colors duration-300"
            >
              {link.name}
            </a>
          ))}
          <a href="/#register">
            <button className="bg-[#FF8000] text-white border-none rounded-lg px-6 py-3 text-lg font-medium cursor-pointer transition-all duration-400 hover:bg-[#FF6B00] hover:shadow-lg min-h-[56px] flex items-center justify-center gap-3">
              Register Interest
            </button>
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-[#1A1A1A]"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-20 left-0 w-full bg-white/95 backdrop-blur-md shadow-lg border-t border-[#E0E0E0] py-6 px-[7.6923%]">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-[#808080] hover:text-[#FF8000] text-lg font-normal transition-colors duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <a href="/#register" onClick={() => setMobileMenuOpen(false)}>
              <button className="w-full bg-[#FF8000] text-white border-none rounded-lg px-6 py-3 text-lg font-medium cursor-pointer transition-all duration-400 hover:bg-[#FF6B00] min-h-[56px] flex items-center justify-center gap-3">
                Register Interest
              </button>
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
